/* eslint-disable @typescript-eslint/no-explicit-any */
import { useGenerateModule } from '@/api/hooks/useGenerateModule';
import { useToast } from '@/hooks/useToast';
import { useParams } from 'react-router-dom';
import { useSaveGeneratedContent } from '@/api/hooks/useSaveGeneratedContent';
import { GenerateContentInput, GenerateSectionOutput } from '@/api/gql/graphql';
import { useGeneratedStoreData } from '@/store/GeneratedDataStore/GeneratedStoreData';
import { useState } from 'react';

// Custom type to handle the API mismatch
type GenerateContentInputWithCustomFinalExam = Omit<
  GenerateContentInput,
  'module'
> & {
  module: {
    sections: GenerateSectionOutput[];
  };
};

export const useGenerator = () => {
  const params = useParams();
  const { showToast } = useToast();
  const { generatedData, setGeneratedData, clearGeneratedData } =
    useGeneratedStoreData();
  const [noContent, setNoContent] = useState(false);
  const { mutate: generateContent, isPending } = useGenerateModule();
  const { mutate: saveGeneratedContent, isPending: isSaving } =
    useSaveGeneratedContent();

  const handleSaveGeneratedContent = (
    data: GenerateContentInputWithCustomFinalExam,
  ) => {
    // Use type assertion to handle the schema/API mismatch
    saveGeneratedContent(data as any, {
      onSuccess: () => {
        showToast('Content saved successfully');
      },
      onError: (error) => {
        showToast(error.message, 'error');
      },
    });
  };

  const handleRegenerateContent = () => {
    clearGeneratedData();
    generateContent(
      { lessonId: params?.lessonId },
      {
        onSuccess: (data) => {
          setGeneratedData(data);
          setNoContent(false);
        },
        onError: (error) => {
          showToast(error.message, 'error');
          setNoContent(true);
        },
      },
    );
  };

  return {
    isPending,
    isSaving,
    modules: generatedData?.sections || [],
    showToast,
    handleSaveGeneratedContent,
    handleRegenerateContent,
    noContent,
  };
};
